module.exports = {"TXTWCL_Other_balances":{"id":"TXTWCL_Other_balances","defaultMessage":"その他の残高"}}